/*
 * @Author       : LiYang
 * @Date         : 2021-09-16 19:09:02
 * @LastEditTime : 2022-08-19 20:09:14
 * @LastEditors  : dengjianjun
 * @Description  :
 */

const raf = (window && window.requestAnimationFrame)
  ? window.requestAnimationFrame.bind(window)
  : function raf (callback) {
    return setTimeout(callback, 1000 / 60)
  }

export function requestAnimationFrame (fn) {
  raf(fn)
}
// 下一次事件循环，一帧执行一次
export function nextFrame () {
  return new Promise(function (resolve, reject) {
    requestAnimationFrame(function () { resolve() })
  })
}

// 多任务事件，一帧帧执行
nextFrame.mapInFrames = function (collection, fn) {
  var queue = Promise.resolve()
  var values = []
  collection.forEach(item => {
    queue = queue.then(() => nextFrame().then(() => values.push(fn(item))))
  })
  return queue.then(() => values)
}
